<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            label-width="160px"
            class="queryform_div"
          >
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('ota.FirmwareName')">
                  <el-input
                    v-model="formselect.name"
                    style="width: 100%"
                    size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('ota.deviceType')">
                  <el-select
                    v-model="formselect.type"
                    :placeholder="$t('desc.select')"
                    style="width: 100%"
                    size="small"
                  >
                    <el-option value="" :label="$t('desc.all')"></el-option>
                    <el-option
                      value="gateway"
                      :label="$t('ota.gateway')"
                    ></el-option>
                    <el-option
                      value="controller"
                      :label="$t('ota.controller')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                <el-button @click="getData" type="primary" size="small">{{
                  $t("button.query")
                }}</el-button>
                <el-button @click="resetKeyword" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>

          <template>
            <el-button
              v-if="hasCreateAuth"
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="showAddDialog(true)"
              style="margin-bottom: 10px"
              >{{ $t("ota.FirmwareUpload") }}</el-button
            >
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                ref="tableData1"
                stripe
                v-loading="loading"
                class="formSTable NoRaidoLabel"
                :empty-text="$t('desc.noData')"
                :height="VersionTHeight"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('ota.FirmwareName')"
                  min-width="30%"
                  prop="versionName"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('ota.VersionNumber')"
                  prop="versionNo"
                  min-width="30%"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('ota.deviceType')"
                  prop="deviceType"
                  min-width="30%"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.creatTime')"
                  prop="creationTime"
                  min-width="30%"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.operate')"
                  width="220"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      v-if="hasUpdateAuth"
                      type="primary"
                      icon="el-icon-edit"
                      circle
                      :title="$t('button.update')"
                      size="mini"
                      @click="edit(scope.row)"
                    ></el-button>
                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.delete')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                        @confirm="delInfo(scope.row.id)"
                      >
                        <el-button
                          v-if="hasDeleteAuth"
                          type="danger"
                          icon="el-icon-delete"
                          :title="$t('button.delete')"
                          circle
                          size="mini"
                          slot="reference"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pagination.totalPage"
                :current-page.sync="pagination.current"
                :page-size="pagination.pageSize"
                @current-change="getData()"
                style="text-align: center; margin-top: 10px"
              ></el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>

    <!-- 固件上传 弹出框 -->
    <el-dialog
      :title="titleName"
      :visible.sync="dialogAdd"
      width="80%"
      top="5vh"
      @close="cancelsEdit"
      ref="editref"
    >
      <el-form ref="formUpdate" :model="formUpdate" label-width="130px">
        <el-row :gutter="24">
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
              :label="$t('ota.FirmwareName')"
              prop="versionName"
              :rules="[{ required: true, message: $t('tips.needed') }]"
            >
              <el-input v-model="formUpdate.versionName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
              :label="$t('ota.deviceType')"
              prop="deviceType"
              :rules="[{ required: true, message: $t('tips.needed') }]"
            >
              <el-select
                v-model="formUpdate.deviceType"
                :placeholder="$t('desc.select')"
                style="width: 100%"
                size="small"
              >
                <el-option
                  value="gateway"
                  :label="$t('ota.gateway')"
                ></el-option>
                <el-option
                  value="controller"
                  :label="$t('ota.controller')"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
              :label="$t('ota.VersionNumber')"
              prop="versionNo"
              :rules="[{ required: true, message: $t('tips.needed') }]"
            >
              <el-input v-model="formUpdate.versionNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
              :label="$t('ota.engineerVersionNo')"
              prop="engineerVersionNo"
            >
              <el-input v-model="formUpdate.engineerVersionNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="24" :sm="24" :xs="24">
            <el-form-item :label="$t('ota.upgradeDesc')">
              <el-input
                v-model="formUpdate.upgradeDesc"
                type="textarea"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              prop="brandCode"
              :label="$t('title.brand')"
              :rules="[
                {
                  required: true,
                  message: this.$t('desc.select'),
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="formUpdate.brandCode"
                :placeholder="$t('desc.select')"
                style="width: 100%"
                clearable
              >
                <el-option
                  :label="brandInfo.brandName"
                  :value="brandInfo.brandCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
              :label="$t('ota.deviceBrand')"
              prop="deviceBrand"
              :rules="[{ required: true, message: $t('tips.needed') }]"
            >
              <el-select
                v-model="formUpdate.deviceBrand"
                :placeholder="$t('desc.select')"
                style="width: 100%"
                size="small"
              >
                <el-option value="HC" label="HC"></el-option>
                <el-option value="InHand" label="InHand"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :md="24">
            <el-form-item :label="$t('ota.FirmwareUpload')">
              <el-upload
                class="upload-demo"
                ref="upload"
                :action="getUrl()"
                :on-preview="handlePreview"
                :on-change="handleChange"
                :on-exceed="handleExceed"
                :before-upload="beforeAvatarUpload"
                :on-success="handleAvatarSuccess"
                :file-list="fileList"
                :data="postData"
                :auto-upload="autoUpload"
                :before-remove="beforeRemove"
                style="width: 45%; min-width: 200px"
              >
                <el-button slot="trigger" size="small" type="primary">{{
                  $t("ota.Upload")
                }}</el-button>
                <!-- <el-button
                  style="margin-left: 10px; border: 0; background: transparent"
                  size="small"
                  ref="submitUpload"
                  @click="submitUpload"
                ></el-button> -->
                <div slot="tip" class="el-upload__tip">
                  {{ $t("ota.UploadFile") }}
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="success" @click="onSubmit">{{
            $t("button.confirm")
          }}</el-button>
          <el-button @click="cancelsEdit">{{ $t("button.cancel") }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  addOTAinfo,
  getAllOTAInfo,
  creatOTAJob,
  deleteOTAInfo,
  updateOtaInfo,
  authOperationCheck,
  getBrandInfos,
  getDeviecModelTree,
  getGatewayOption,
  getAllCustomer,
  batchCreatOTAJob,
  getOtaDetail,
  saveUpgradeDevices,
  pushJobFile,
  pushInstallCommand,
} from "../../api/api";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "index",
  data() {
    return {
      submitBtn: true,
      checkRes: false,
      titleName: "",
      loading: false,
      autoUpload: false,
      dialogAdd: false,
      dialogmassUpdate: false,
      dialogUpdateResult: false,
      props: { multiple: true },
      VersionTHeight: 500,
      formselect: {
        name: "",
        type: "",
      },
      tableData1: [],
      brandInfo: {},
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      formUpdate: {
        versionName: "",
        deviceType: "",
        versionNo: "",
        describeContent: "",
        brandCode: "",
        upgradeDesc: "",
        deviceBrand: "",
        engineerVersionNo: "",
      },
      postData: {},
      fileList: [],
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      hasOtaUpgradeAuth: false,
      formMassUpdate: {},
      otaDeviceList: [],
      DeviceTable: [],
      gsnList: [],
      otaId: "",
      ResultForm: {
        table: [
          { customer: "e214发货不额外吧", state: "success" },
          { state: "failure" },
          { state: "load" },
        ],
      },
      dialogTimeUpgrade: false,
      tableLoading: false,
      UpdateForm: {},
    };
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  created: function () {
    this.authOperation("Ota");
  },
  mounted() {
    this.getBrandInfos();
    this.getData();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasOtaUpgradeAuth = res.hasOtaUpgradeAuth;
    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    getData() {
      this.loading = true;
      var data = {
        name: this.formselect.name,
        type: this.formselect.type,
      };
      data.SkipCount = (this.pagination.current - 1) * this.pagination.pageSize;
      data.MaxResultCount = this.pagination.pageSize;
      getAllOTAInfo(data).then((res) => {
        if (res.success) {
          this.pagination.totalPage = res.result.totalCount;
          this.loading = false;
          this.tableData1 = res.result.items;
        }
      });
    },
    //上传路径获取
    getUrl() {
      let imgactionurl = "";
      if (process.env.NODE_ENV === "development") {
        imgactionurl =
          this.$baseConfig.VUE_APP_LocalRootUrl +
          "api/services/app/Ota/UploadOtaFile"; //这是调用测试数据接口
      } else {
        imgactionurl =
          this.$baseConfig.VUE_APP_PublishRootUrl +
          "api/services/app/Ota/UploadOtaFile"; //线上
      }
      return imgactionurl;
    },
    handleAccredit(index, row) {},
    handleDelete(index, row) {},

    onSubmit() {
      let data = this.formUpdate;
      let formData = new FormData();
      for (let property in data) {
        formData.append(property, data[property]);
      }
      this.fileList.forEach((element) => {
        formData.append("fileList", element.raw);
      });
      this.$refs["formUpdate"].validate((valid) => {
        if (valid) {
          if (this.dialogType == "add") {
            delete data.id;
            addOTAinfo(formData)
              .then((res) => {
                if (res.success) {
                  this.$message.success("success");
                  this.dialogAdd = false;
                  this.fileList = [];
                  this.getData();
                } else {
                  this.$message.error(res.error.message);
                }
              })
              .catch((err) => {
                this.$message.error(err.error.message);
              });
          } else {
            updateOtaInfo(formData)
              .then((res) => {
                if (res.success) {
                  this.$message.success("success");
                  this.dialogAdd = false;
                  this.fileList = [];
                  this.getData();
                } else {
                  this.$message.error(res.error.message);
                }
              })
              .catch((err) => {
                this.$message.error(err.error.message);
              });
          }
        }
      });
    },

    //上传前校验
    handleChange(file, fileList) {
      if (file.status === "ready") {
        this.$refs["formUpdate"].validate((valid) => {
          if (valid) {
            this.fileList = fileList;
          } else {
            file = "";
            this.fileList = [];
          }
        });
      }
    },

    handleExceed(files, fileList) {
      this.$message.warning(this.$t("ota.tipsMessage1"));
    },

    beforeRemove(file, fileList) {
      if (this.checkRes) {
        return this.$confirm(
          this.$t("ota.cofirmDelete") + "  '" + `${file.name}` + "'?",
          {
            confirmButtonText: this.$t("desc.yes"),
            cancelButtonText: this.$t("desc.no"),
          }
        ).then((action) => {
          this.submitBtn = true;
          // console.log(this.formUpdate.id)
        });
      }
    },

    handlePreview() {},

    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "7z" ||
        testmsg === "rar" ||
        testmsg === "zip" ||
        testmsg === "bin" ||
        testmsg === "BIN" ||
        testmsg === "Bin" ||
        testmsg === "xlsx";
      if (!extension) {
        this.$message({
          message: this.$t("ota.tipsMessage2"),
          type: "error",
        });
        this.checkRes = false;
        return this.checkRes;
      } else {
        this.checkRes = true;
      }
    },

    submitUpload() {
      this.postData.versionNo = this.formUpdate.versionNo;
      this.$refs.upload.submit();
    },

    handleAvatarSuccess(res, file) {},
    showAddDialog(visible) {
      this.dialogAdd = visible;
      this.dialogType = "add";
      this.titleName = this.$t("ota.create");
      if(visible){
        let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
        this.$set(this.formUpdate, "brandCode", brand);
      }
    },

    edit(row) {
      this.dialogAdd = true;
      this.dialogType = "edit";
      this.titleName = this.$t("ota.edit");
      this.formUpdate = JSON.parse(JSON.stringify(row));
      row.fileList.forEach((element) => {
        let file = {
          name: element.fileName,
          url: element.fileUrl,
        };
        this.fileList.push(file);
      });

      this.submitBtn = false;
    },

    resetKeyword() {
      this.formselect = {
        name: "",
        type: "",
      };
    },
    cancelsEdit() {
      this.dialogAdd = false;
      this.fileList = [];
      this.formUpdate = {};
      this.$refs["formUpdate"].resetFields();
    },
    //删除
    delInfo(e) {
      deleteOTAInfo(e).then((res) => {
        if (res.success) {
          this.$message.success(this.$t("tips.deleteSuccess"));
          this.getData();
        }
      });
    },
    //分页数据
    handleCurrentChange(val) {
      this.pagination.current = val;
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
    },

    handleSelectionChange(val) {
      this.gsnList = val.map((x) => x.gsn);
    },
    showUpdateDialog(visible) {
      this.dialogUpdate = visible;
      this.VersionTHeight = window.innerHeight * 0.9 - 230 + "px";
    },
    async getBrandInfos() {
      let that = this;
      let res = await getBrandInfos();
      let brandCode = localStorage.getItem("user_brand")
        ? localStorage.getItem("user_brand")
        : "IR";
      that.brandInfo = res.result.find((x) => x.brandCode == brandCode);
    },

    cancels() {
      let that = this;
      that.dialogmassUpdate = false;
      this.$refs[this.refForm].resetFields();
    },
    async otaUpdate() {
      let that = this;
      let data = {
        Id: this.otaId,
        GsnList: this.gsnList,
      };
      //let res = await batchCreatOTAJob(data);
      let res = await saveUpgradeDevices(data);
      try {
        if (res.result === true) {
          that.$message.success(this.$t("ota.upgradeDeviceSaveSuccess"));
          that.cancels();
        } else {
          that.$message.warning(res.result.description);
        }
      } catch (error) {
        this.$message.error(error.error.message);
      }
    },

    async pushJobFile() {
      let that = this;
      let data = {
        Id: this.otaId,
        GsnList: this.gsnList,
      };
      let res = await pushJobFile(data);
      try {
        if (res.result.isSuccess === true) {
          that.$message.success(this.$t("ota.upgradeFileSending"));
          that.cancels();
        } else {
          that.$message.warning(res.result.description);
        }
      } catch (error) {
        this.$message.error(error.error.message);
      }
    },

    async pushInstallCommand() {
      let that = this;
      let data = {
        Id: this.otaId,
        GsnList: this.gsnList,
      };
      let res = await pushInstallCommand(data);
      try {
        if (res.result.isSuccess === true) {
          that.$message.success(this.$t("ota.upgradeInstallSending"));
          that.cancels();
        } else {
          that.$message.warning(res.result.description);
        }
      } catch (error) {
        this.$message.error(error.error.message);
      }
    },

    async getOtaDetail(otaId) {
      let that = this;
      let postData = {
        otaId: otaId,
        language: that.activeLang,
      };
      let res = await getOtaDetail(postData);
      that.ResultForm = res.result;
    },
  },
};
</script>

 